<!--  -->
<template>
  <ControlCenterLayout type="api">
    <BaseLayout>
      <div class="lg:tw-mt-8 tw-mt-5 tw-flex tw-w-full tw-gap-4">
        <ApiMenu class="tw-hidden md:tw-block"></ApiMenu>
        <div class="tw-flex-1 app-main lg:tw-mb-0 tw-mb-4">
          <router-view></router-view>
        </div>
      </div>
    </BaseLayout>
  </ControlCenterLayout>
</template>
<script>
import BaseLayout from "@/layout/BaseLayout.vue";
import ControlCenterLayout from "@/layout/ControlCenterLayout.vue";
import ApiMenu from "./components/api-menu.vue";
export default {
  name: "index",
  props: {},
  components: { BaseLayout, ControlCenterLayout, ApiMenu },
  data() {
    return {};
  },
  computed: {
    // 路径
    path() {
      return this.$route.path;
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.app-main {
  width: calc(100% - 260px);
  height: 100%;
  padding: 0 8px;
  min-width: 0;
}
.api-menu {
  flex-shrink: 0; // 防止菜单被压
}
</style>
